










function Video (params) {
    this.button = params.buttonClassName;
    this.videoID = params.videoId;

    const _self = this;

    let currentVideo = null;


    this.init = function () {
        this.bindEvents();
    }

    // 赋予事件
    this.bindEvents = function () {
        $(this.button).click(function () {
            let key = this.dataset.key;
            currentVideo = document.getElementById(_self.videoID + key);
        
            let { paused } = _self.changeVideo('paused');
        
        
            if (paused) {
                $(this).addClass('video-paused');
            } else {
                $(this).removeClass('video-paused');
            }
        });
    };



    // 视频操作
    this.changeVideo = function (dir) {
        switch (dir) {
            case 'paused':
                this.videoPaused();
                break;
            case 'muted':
                this.videoMuted();
                break;
            default:
                break;
        }
    
        return {
            paused: currentVideo.paused,
            muted: currentVideo.muted
        }
    };


     // 播放
    this.videoPaused =function () {
        if (currentVideo.paused) {
            currentVideo.play();

        } else {
            currentVideo.pause();
        }
    };


    // 声音
    this.videoMuted = function () {
        currentVideo.muted = !currentVideo.muted;
    };






    this.init();
};


new Video({
    buttonClassName: '.desktop-paused-button',
    videoId: 'desktop-video-'
});